import "./App.css";
import BioLink from "./components/BioLink";

function App() {
    return <BioLink />;
}

export default App;
